module.exports = __webpack_public_path__ + "img/imgXharra-7.d17dc0cc.png";